import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  private readonly LAST_URL_KEY = 'lastVisitedUrl';

  constructor(private router: Router) {
    // Подписываемся на события навигации
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      // Сохраняем URL при каждой успешной навигации
      this.saveLastUrl(event.urlAfterRedirects);
    });
  }

  private saveLastUrl(url: string): void {
    if (url && !url.includes('auth')) {
      // Не сохраняем URL страниц авторизации
      localStorage.setItem(this.LAST_URL_KEY, url);
    }
  }

  getLastVisitedUrl(): string {
    return localStorage.getItem(this.LAST_URL_KEY) || '/cabinet/all/load/list';
  }
}
